import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const UserDashboardProfileWizardModalContainerLoadable = clientOnlyLazy({
  loader: () => import('./UserDashboardProfileWizardModalContainer.dynamic'),
  loading: LoadingModal,
});
